import { toZonedTime, fromZonedTime, format } from 'date-fns-tz';
import { getDay, setHours, setMinutes, setSeconds, setMilliseconds, addDays, differenceInCalendarDays } from 'date-fns';

/**
 * Calculates the Date object for the next Wednesday at the specified time in EST.
 * @returns {Date | null} The Date object for the next auction, or null if calculation fails.
 */
export const getNextAuctionTimeEST = () => {
  try {
    const timeZone = 'America/New_York';
    const targetDayOfWeek = process.env.REACT_APP_AUCTION_DAY ; // Wednesday
    const targetHour = process.env.REACT_APP_AUCTION_HOUR ;
    const targetMinute = process.env.REACT_APP_AUCTION_MINUTE ;

    // 1. Get current time in EST
    const now = new Date();
    const nowInEST = toZonedTime(now, timeZone);
    const currentDayOfWeek = getDay(nowInEST);
    // console.log(`Current time in EST: ${format(nowInEST, 'yyyy-MM-dd HH:mm:ss zzzz', { timeZone })} (Day: ${currentDayOfWeek})`);

    // 2. Calculate days until next Wednesday
    let daysUntilNextWednesday = (targetDayOfWeek - currentDayOfWeek + 7) % 7;

    // 3. Set the target date to the next Wednesday
    let nextWednesday = addDays(nowInEST, daysUntilNextWednesday);
    let targetTime = setMilliseconds(setSeconds(setMinutes(setHours(nextWednesday, targetHour), targetMinute), 0), 0);

    // 4. If today is Wednesday and current time is after or at 11:00 AM, move to next week's Wednesday
    if (daysUntilNextWednesday === 0 && nowInEST >= targetTime) {
      targetTime = addDays(targetTime, 7);
    }

    // 5. Convert the final EST date/time back to a standard UTC Date object
    const finalTargetDateUTC = fromZonedTime(targetTime, timeZone);
    // console.log(`Final target date object (UTC/Epoch): ${finalTargetDateUTC.toISOString()}`);

    return finalTargetDateUTC;

  } catch (error) {
    // console.error("Error calculating next auction time:", error);
    return null;
  }
}; 